// Service for Monthly Cuts — Sincronización con rex+ remuneraciones (ASIS-4945)
import { apiClient, API_CONFIG } from '@/api/core';
import type { ApiResponse } from '@/api/shared';
import type {
  LC_SyncMonthlyCutsRexIn,
  LC_SyncMonthlyCutsRexOut,
  SyncMonthlyCutsRexInput,
} from '../types';


export class MonthlyCutsRexSyncService {
  // POST /v1/monthlycuts/management/rex-synchronizations
  // Asigna el proceso de rex+ a los cortes indicados del holding del usuario que aún no lo tienen.
  // Los que ya tenían proceso viajan en alreadySyncedIds, los que fallaron contra rex+ en
  // failedIds, los de empresas sin integración en notApplicableIds y los ajenos en notFoundIds.
  async sync(
    input: SyncMonthlyCutsRexInput,
    signal?: AbortSignal,
  ): Promise<ApiResponse<LC_SyncMonthlyCutsRexOut>> {
    const body: LC_SyncMonthlyCutsRexIn = { monthlyCutIds: input.monthlyCutIds };
    return apiClient.post<LC_SyncMonthlyCutsRexOut>(
      API_CONFIG.ENDPOINTS.MONTHLY_CUTS_REX_SYNCHRONIZATIONS,
      body,
      { signal },
    );
  }
}

export const monthlyCutsRexSyncService = new MonthlyCutsRexSyncService();
